import { IDefineCommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { CommunicatorService } from 'ui-ng-component-communicator';
import { ORM } from 'utility-ts-orm';
import { IAPMultiTermDatasource } from '../datasources/ap_multi_student_term_datasource';
import { IAPMmTemplateSlotDatasource } from '../datasources/ap_multi_template_slot_dataSource';
import { IAPMmDevReqTemplateSlotDatasource } from '../datasources/ap_multi_templatedev_req_slot_dataSource';
import { APMmDataHelper } from '../helpers/ap_multi_plan_helper';
import { INotificationDelegate } from '../helpers/notification_delegate';

angular
  .module('capability-ng-academic-planner')
  .service(
    'loadMmAcademicPlanCommand',
    (
      defineCommandORM: IDefineCommand,
      $http: ng.IHttpService,
      ngAPMmDataHelper: APMmDataHelper,
      ngAPMultiTermDatasource: IAPMultiTermDatasource,
      ngAPNotificationDelegate: INotificationDelegate,
      ngComponentCommunicatorService: CommunicatorService,
      log: any
    ) => {
      return defineCommandORM('loadMmAcademicPlanCommand', (deferred, studentId = 0) => {
        ngComponentCommunicatorService.publish('PLAN_LOADING');
        $http
          .get(`/academicplan/students/${studentId}/course_plan`)
          .then(({ data }: any) => {
            ngComponentCommunicatorService.publish('PLAN_LOADING_SUCCESS');
            const termsData = ngAPMmDataHelper.constructStudentTermsData(data.data);
            ngAPMultiTermDatasource.clear().write(termsData);
            deferred.resolve();
          })
          .catch(() => {
            ngComponentCommunicatorService.publish('PLAN_LOADING_FAILURE');
            ngAPNotificationDelegate.error(`Unable to load student plan`);
            log.issue('failed to load student plan');
            deferred.reject();
          });
      });
    }
  );



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/commands/load_multi_academic_plan_command.ts